<template>
  <div>
    <basic-portlet title="New Live Feed">
      <!-- The Form -->
      <FormulateForm
        @submit="submit">
        <div class="row">
          <!-- Left Side -->
          <div class="col-12 col-md-4">
            <div class="row">
              <div class="col-12">
                <FormulateInput v-model="live_feed_name"
                                v-debounce:5s="checkMountsAreFree"
                                type="text"
                                outer-class="mb-4"
                                input-class="form-control"
                                name="live feed name"
                                label="Name Your Live Feed"
                                placeholder="Name your Live Feed">
                  <template #label="{ label, id }">
                    <label :for="id">
                      <strong>{{ label }}</strong>
                      <span v-tooltip="{content: getLiveFeedNameTooltip}">
                        <i class="ml-2 cursor-pointer fa fa-question-circle" />
                      </span>
                    </label>
                  </template>
                </FormulateInput>
              </div>
              <div class="col-12">
                <!-- Artwork selection -->
                <div class="w-75">
                  <display-with-selection-modal :preselected-artwork="artwork_to_display" @selected="(ev) => (selected_artwork = ev.selected_artwork)">
                    <template slot="label">
                      <label style="font-weight: bold">Artwork</label>
                    </template>
                  </display-with-selection-modal>
                </div>
                <!-- End artwork selection -->
                <!-- Start Playlist Groups -->
                <div v-show="live_feed_name" class="row">
                  <FormulateInput v-model="playlist_group_data"
                                  outer-class="w-100"
                                  type="group"
                                  validation="min:1,length"
                                  :limit="3"
                                  :repeatable="true"
                                  add-label="Add Feed"
                                  name="Feeds">
                    <template #addmore="{addMore}">
                      <div class="row">
                        <div class="col-12">
                          <button id="add_new_feed_button" style="display: none"
                                  class="btn btn-ss-standout btn-icon-sm"
                                  @click.prevent="addMore">
                            <i class="flaticon2-plus" />Add Additional Feed
                          </button>
                        </div>
                      </div>
                    </template>

                    <!-- Start Playlists Loop -->
                    <template #repeatable="{index, removeItem}">
                      <div class="col-12 float-left mb-4">
                        <div class="card">
                          <div class="card-body">
                            <div class="mb-4">
                              <label><strong>Select a Feed</strong></label>
                              <multiselect :id="`feeds_multiselect_${index}`"
                                           ref="multiselect"
                                           v-model="selected_feeds[index]"
                                           label="name"
                                           track-by="uuid"
                                           name="playlists"
                                           :multiple="false"
                                           :searchable="true"
                                           :internal-search="true"
                                           :clear-on-select="false"
                                           :close-on-select="true"
                                           :options-limit="10"
                                           :option-height="50"
                                           :max-height="300"
                                           :allow-empty="false"
                                           :show-no-results="false"
                                           :hide-selected="true"
                                           :options="feeds">
                                <template #singleLabel="props">
                                  <img style="height:50px;" class="option__image"
                                       :src="props.option.feed_artwork_thumbnail_url"
                                       :alt="props.option.slug">
                                  <span class="option__desc">
                                    <span class="option__title">{{ props.option.name }}
                                    </span>
                                  </span>
                                </template>
                                <template #option="props">
                                  <img style="height:50px;" class="option__image"
                                       :src="props.option.feed_artwork_thumbnail_url"
                                       :alt="props.option.slug">
                                  <div class="option__desc">
                                    <span class="option__title">{{ props.option.name }}</span>
                                    <span class="option__small">{{ props.option.description }}</span>
                                  </div>
                                </template>
                              </multiselect>
                            </div>

                            <FormulateInput :options="{normal: 'Normal', randomize: 'Shuffle', random: 'Random'}"
                                            type="select"
                                            name="mode"
                                            :value="playlist_group_data[index].mode || 'normal'"
                                            validation="required"
                                            outer-class="mb-4"
                                            input-class="form-control"
                                            placeholder="Select a mode"
                                            label="Select a mode">
                              <template #label="{ label, id }">
                                <label :for="id">
                                  <strong>{{ label }}</strong>
                                  <span v-tooltip="{content: getModeTooltip()}"><i class="ml-2 cursor-pointer fa fa-question-circle" /></span>
                                </label>
                              </template>
                            </FormulateInput>

                            <FormulateInput :value="playlist_group_data[index].reload_mode"
                                            :options="{seconds: 'Seconds', 'never': 'Never'}"
                                            type="select"
                                            name="reload_mode"
                                            outer-class="mb-4"
                                            input-class="form-control"
                                            validation="required"
                                            :validation-messages="{required: 'Reload mode is required'}"
                                            placeholder="Select a reload mode"
                                            label="Select a reload mode">
                              <template #label="{ label, id }">
                                <label :for="id">
                                  <strong>{{ label }}</strong>
                                  <span v-tooltip="{content: getReloadModeTooltip()}"><i class="ml-2 cursor-pointer fa fa-question-circle" /></span>
                                </label>
                              </template>
                            </FormulateInput>

                            <FormulateInput v-show="playlist_group_data[index].reload_mode === 'seconds'"
                                            type="number"
                                            outer-class="mb-4"
                                            input-class="form-control"
                                            name="reload"
                                            :label="`Reload (${playlist_group_data[index].reload_mode})`"
                                            :value="playlist_group_data[index].reload || 1"
                                            validation="required|number|min:0"
                                            :min="0"
                                            error-behavior="live">
                              <template #label="{ label, id }">
                                <label :for="id">
                                  <strong>{{ label }}</strong>
                                  <span v-tooltip="{content: getRoundsTooltip(playlist_group_data[index].reload_mode)}">
                                    <i class="ml-2 cursor-pointer fa fa-question-circle" />
                                  </span>
                                </label>
                              </template>
                            </FormulateInput>

                            <button v-show="playlist_group_data.length > 1" type="button"
                                    class="btn btn-ss-danger w-100"
                                    @click.prevent="removeItem(); removeSelectedFeedIndex(index)">
                              <i class="flaticon2-cross" /> Remove Feed
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- End Playlists Loop -->
                  </FormulateInput>
                </div>
                <!-- End Playlist Groups -->
              </div>
            </div>
          </div>
          <!-- End Left Side -->
          <!-- Start Right Side -->
          <div class="col-7 offset-1 d-none d-md-block">
            <live-feed-create-help />
          </div>
          <!-- End Right Side -->
        </div>

        <!-- Start Output Groups -->

        <div v-show="!nullish(live_feed_name) && live_feed_name !== ''" v-if="playlist_group_data.length > 0" class="row border-bottom mt-4 mb-4">
          <div class="col-12">
            <h5>Outputs</h5>
          </div>
        </div>

        <div v-show="!nullish(live_feed_name) && live_feed_name !== ''" class="row">
          <FormulateInput v-if="playlist_group_data.length > 0"
                          v-model="output_values"
                          outer-class="w-100"
                          type="group"
                          name="outputs"
                          :repeatable="true"
                          add-label="+ Add output"
                          validation="min:1,length"
                          :value="premium_config.outputs"
                          :limit="3">
            <template #addmore="{addMore}">
              <button id="add_new_output_button" type="button"
                      class="btn btn-ss-standout btn-icon-sm"
                      @click="addMore(); checkMountsAreFree()">
                <i class="flaticon2-plus" />Add Additional Output
              </button>
            </template>

            <!-- Start Outputs Loop -->
            <template v-if="!nullish(live_feed_name) || live_feed_name === ''" #repeatable="{index, removeItem}">
              <div class="col-12 col-md-4 float-left mb-4">
                <div class="card">
                  <div class="card-body">
                    <div v-if="live_feed_name">
                      <label for="mount_name"><strong>Mount #{{ index + 1 }}</strong></label>
                      <input id="mount_name" type="text"
                             class="form-control mb-4"
                             disabled :value="output_values_with_mount_names[index].mount">
                    </div>

                    <FormulateInput type="select"
                                    outer-class="mb-4"
                                    input-class="form-control"
                                    placeholder="Select a format"
                                    name="format"
                                    :value="output_values[index].format || 'mp3'"
                                    :options="{mp3: 'MP3', aac: 'AAC-AUTO', aac_lc: 'AAC-LC', he_aac: 'AAC-HE', he_aac_v2: 'AAC-HE v2'}"
                                    validation="required"
                                    label="Format"
                                    @input="checkMountsAreFree">
                      <template #label="{ label, id }">
                        <label :for="id">
                          <strong>{{ label }}</strong>
                          <span v-tooltip="{content: getFormatTooltip()}">
                            <i class="ml-2 cursor-pointer fa fa-question-circle" />
                          </span>
                        </label>
                      </template>
                    </FormulateInput>

                    <FormulateInput type="select"
                                    outer-class="mb-4"
                                    input-class="form-control"
                                    name="bitrate"
                                    placeholder="Select a bitrate"
                                    value="128"
                                    :options="formatBitrateOptions(index)"
                                    validation="^required|number|not:undefined"
                                    label="Bitrate"
                                    @input="checkMountsAreFree">
                      <template #label="{ label, id }">
                        <label :for="id">
                          <strong>{{ label }}</strong>
                          <span v-tooltip="{content: getBitrateToolTip()}">
                            <i class="ml-2 cursor-pointer fa fa-question-circle" />
                          </span>
                        </label>
                      </template>
                    </FormulateInput>

                    <a v-show="output_values.length > 1" class="btn btn-ss-danger w-100"
                       @click.prevent="removeItem();">
                      <i class="flaticon2-cross" /> Remove Output
                    </a>
                  </div>
                </div>
              </div>
            </template>
            <!-- End Outputs Loop -->
          </FormulateInput>
        </div>
        <!-- End Output Groups -->

        <div v-show="live_feed_name && !nullish(selected_artwork)" v-if="playlist_group_data.length > 0" class="row border-top mt-4">
          <div v-if="submission_blocked" class="col-12 mt-4">
            <button type="button" class="btn btn-ss-standout cursor-not-allowed" disabled>
              Submit
            </button>
          </div>
          <div v-else class="col-12 mt-4">
            <FormulateInput v-perms.disable="['api.live-feeds.store']"
                            input-class="mt-4 btn btn-ss-standout"
                            type="submit"
                            label="Submit" />
          </div>
        </div>
      </FormulateForm>
    </basic-portlet>
    <quick-alert-modal v-bind="quick_alert" />
  </div>
</template>

<script>

import LiveFeedsMixin from "VueMixins/Feeds/LiveFeedsMixin";
import VueFormulate from '@braid/vue-formulate';
import vueDebounce from 'vue-debounce';
import toastr from 'toastr';
import BasicPortlet from "VueComponents/BasicPortlet";
window.Vue.use(vueDebounce);
import VTooltip from 'v-tooltip';
Vue.use(VTooltip);
const slugify = require('slugify');
import { nullish } from 'Lib/type-sanity';
import LiveFeedCreateHelp from "VuePartials/LiveFeeds/LiveFeedCreateHelp";
import DisplayWithSelectionModal from 'VuePartials/Artwork/DisplayWithSelectionModal';

export default {
  components: {
    LiveFeedCreateHelp,
    BasicPortlet,
    DisplayWithSelectionModal,
  },
  mixins: [LiveFeedsMixin],
  data: () => ({
    customer_id: window.customer_id,
    live_feed_name: null,
    playlist_group_data: [],
    feeds: [],
    selected_feeds: [],
    playlists: [],
    ads_enabled: false,
    premium_config: {
      "version": 2,
      "feed": 'premiumv2',
      "type": "playlist",
      "playlists": [],
      "outputs": [],
      "customer_slug": null,
      "ingest_group": "premium",
      "edge_group": "audio",
      "with_backup": true,
    },
    validation: {},
    output_values: [],
    output_options: {
      mp3: {
        64: '64',
        96: '96',
        112: '112',
        128: '128 (recommended)',
        192: '192',
        256: '256',
        320: '320',
      },
      aac: {
        48: '48',
        56: '56',
        64: '64',
        96: '96',
        112: '112',
        128: '128',
        192: '192',
        256: '256',
        320: '320',
      },
      aac_lc: {
        56: '56',
        64: '64',
        96: '96',
        112: '112',
        128: '128',
        256: '256',
        320: '320',
      },
      he_aac: {
        48: '48',
        56: '56',
        64: '64',
        96: '96',
        112: '112',
        128: '128',
      },
      he_aac_v2: {
        48: '48',
        56: '56',
      },
    },
    // if you want to forbid any specific substrings to be used as stream
    disallowedStreamsArray: [],
    selected_artwork: null,
  }),

  computed: {
    submission_blocked() {
      return (!this.permissionsCanDoAction('api.live-feeds.store') || nullish(this.selected_artwork));
    },
    /**
     * Generate a slugified and safe version of the live_feed_name for the mounts names.
     * This is for display purposes only, it will be generated again on the backend by laravel Str::slug
     */
    output_values_with_mount_names() {
      if (this.output_values.length < 1 || nullish(this.live_feed_name)) {
        return [];
      }

      // Create unreactive copy of mounts
      const renamed_mounts = JSON.parse(JSON.stringify(this.output_values));

      // Replace URL friendly characters with mount name safe characters
      slugify.extend({ '%': '_', '<': '_', '>': '_', '&': 'and', '-': '_' });

      renamed_mounts.map((renamed_mount) => {
        const customer_id = this.customer_id ? this.customer_id : '{customer_id}';
        const feed_name_slugged = slugify(this.live_feed_name, '_');
        const format = renamed_mount.format ? renamed_mount.format : 'mp3';
        const bitrate = renamed_mount.bitrate ? renamed_mount.bitrate : Object.keys(this.output_options[format])[0];
        renamed_mount.mount = `${customer_id}_${feed_name_slugged}_${bitrate}_${format}`.toLowerCase();
      });

      return renamed_mounts;
    },

    artwork_to_display() {
      if (this.selected_artwork) {
        return this.selected_artwork;
      }

      return null;
    },
  },

  beforeMount() {
    window.Vue.use(VueFormulate, {
      rules: {
        disallowedMountNames: ({ value }) => this.matchDisallowedMountNames(value),
      },
    });

    this.fetchFeeds();
    this.premium_config.customer_slug = window.Laravel.user.customer.slug;

    // set server to ads group if customer has ads_enabled in the customers table
    this.ads_enabled = Boolean(window.Laravel.user.customer.ads_enabled);
    if (this.ads_enabled) {
      this.premium_config.edge_group = 'ads';
    }
  },
  mounted() {
    // Ensure that we always have one feed and one output
    $(`#add_new_feed_button`).click();
    Vue.nextTick(() => {
      $(`#add_new_output_button`).click();
    });

    EventBus.$on('new_artwork_selected', (payload) => {
      toastr.success("New Artwork Selected.");
      this.selected_artwork = payload;
    });
  },
  methods: {
    /**
     *  Removes specific index in the group of the selected_feeds data variable.
     *  This prevents multiselect still being selected after group has been removed.
     */
    removeSelectedFeedIndex(index) {
      this.$delete(this.selected_feeds, index);
    },

    format(index) {
      return Array.isArray(this.output_values) &&
        this.output_values[index] &&
        this.output_values[index].format;
    },

    formatBitrateOptions(index) {
      const type = this.format(index);
      const output_options = type ? this.output_options[type] : {};
      const output_values = this.output_values[index] || {};
      const bitrate = output_values.bitrate;
      if (bitrate && !output_options[bitrate]) {
        this.$delete(this.output_values[index], 'bitrate');
      }
      return output_options;
    },

    checkMountsAreFree() {
      _.forEach(this.output_values_with_mount_names, (output) => {
        this.checkMountIsFree(output.mount);
      });
    },

    async checkMountIsFree(value) {
      const free = await this.checkMount(value);
      if (!free) {
        toastr.error(`${value} is taken. Please pick another name!`);
      }
    },

    /**
    * Simple check to disallow some names.
    * This function is more or less static for now and can be made dynamic later!
    */
    matchDisallowedMountNames(value) {
      const substrings = this.disallowedStreamsArray;
      for (const substring of substrings) {
        if (value.includes(substring)) {
          return false;
        }
      }

      return !(value === 'untitled' || value === 'untitled.mp3' || value === 'untitled.aac');
    },

    /**
    * Check if mount (stream) exists
    * Do not check if it is called "untitled"
    */
    async checkMount(value) {
      if (value !== '' && value !== 'untitled') {
        const response = await axios.post(
          `/api/v1/live-feeds/mount/exists`, {
            'mount': value,
          },
        );

        return !response.data.exists;
      }

      // if empty return true and depend on 'required' rule
      return true;
    },

    async fetchFeeds() {
      const feeds = await axios.get(
        `/api/v1/feeds`,
      );

      this.feeds = feeds.data.data;
    },

    async submit() {
      try {
        // Make clones of the arrays
        const feeds_selected_copy = _.cloneDeep(this.selected_feeds);
        const playlist_group_data_copy = _.cloneDeep(this.playlist_group_data);

        // Iterate cloned arrays and adjust rename / adjust required keys
        // Assign options based on form date based on key
        Object.keys(feeds_selected_copy).forEach((key) => {
          feeds_selected_copy[key].feed_uuid = feeds_selected_copy[key].uuid;
          feeds_selected_copy[key].feed_name = feeds_selected_copy[key].name;
          feeds_selected_copy[key].name = 'tracks';
          feeds_selected_copy[key].url = feeds_selected_copy[key].feed_pls_file_url;
          feeds_selected_copy[key].options = {
            "mode": playlist_group_data_copy[key]['mode'],
            "reload_mode": playlist_group_data_copy[key]['reload_mode'],
            "reload": Number(playlist_group_data_copy[key]['reload']),
          };
        });

        // Remove unnecessary date from array
        const feeds_selected = [];
        for (const feed_selected of feeds_selected_copy) {
          feeds_selected.push(_.pick(feed_selected, _.keys({
            feed_name: null,
            feed_uuid: null,
            name: null,
            url: null,
            options: null,
          })));
        }

        // Vue force set the object value to premium_config
        this.$set(this.premium_config, 'playlists', feeds_selected);
        // Set premium config with values set separately conditionally
        this.$set(this.premium_config, 'outputs', this.output_values_with_mount_names);

        const feed_slugs = [];
        const feed_uuids = [];
        for (const selected_feed of this.selected_feeds) {
          feed_slugs.push(selected_feed.slug);
          feed_uuids.push(selected_feed.uuid);
        }

        // Check if at least 1 feed was selected
        if (_.isEmpty(feed_slugs)) {
          this.quickAlert({
            message: `Please select at least 1 feed!`,
            title: `Error!`,
            variant: `error`,
          });
          return;
        }

        // Check if any added playlist is selected
        const feed_slug_length = feed_slugs.length;
        const total_added_feed_group_length = this.playlist_group_data.length;
        if (feed_slug_length < total_added_feed_group_length) {
          this.quickAlert({
            title: `Error!`,
            message: `You have added ${total_added_feed_group_length} feed(s) but only ${feed_slug_length} were selected`,
            variant: `error`,
          });
          return;
        }

        this.premium_config.feed = this.live_feed_name;

        // Due to issue with inability to reset validation on select when options change dynamically,
        // Check if any bitrates were deselected when switching to a different format and early return alert to select it,
        // otherwise, empty value will be submitted.
        for (const [key, output] of Object.entries(this.premium_config.outputs)) {
          if (!output['bitrate']) {
            this.quickAlert({
              title: `Error!`,
              message: `Please select a bitrate for Mount #${Number(key) + 1}!`,
              variant: `error`,
            });
            return;
          }
        }

        // Submit the request
        // Extra is anything timbre needs for itself
        // Payload is the structure to be passed to Portal
        const response = await axios.post(`/api/v1/live-feeds`, {
          'action': 'create',
          'extra': {
            'name': this.live_feed_name,
            'slugs': feed_slugs,
            'uuids': feed_uuids,
            'artwork_id': this.selected_artwork.uuid,
          },
          'payload': this.premium_config,
        });

        if (response.data.success) {
          this.quickAlert({
            title: `Created!`,
            message: `Live feed created successfully! Redirecting...`,
            variant: `success`,
          });

          // Redirect the user to live feed details.
          const live_feed_uuid = response.data.data.uuid;
          window.location.href = `/live-feeds/${live_feed_uuid}`;
        } else {
          this.quickAlert({
            title: `Failed!`,
            message: _.capitalize(response.data.error.message),
            variant: `error`,
          });
        }
      } catch (error) {
        let error_response = "Exception has occurred. Please ensure all required fields are filled out correctly!";

        if (error.response.data?.error?.message) {
          error_response = error.response.data.error.message;
        }

        this.quickAlert({
          title: `Oops!`,
          message: error_response,
          variant: `error`,
        });
      }
    },
  },

};
</script>

<style lang='scss'>
  .tooltip {
    opacity:1;
  }
  .formulate-input-label {
    font-size: larger;
    font-weight: bolder;
  }

   .formulate-input-errors {
     color:red;
   }

  .formulate-input-help {
      color: gray;
  }

</style>
